import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Container,
  KeyboardView,
  Wrapper,
  Card,
  CardBody,
  Title,
  Copy
} from "app/NativeComponents/common";
import { Header, MenuItem, ToggleSwitch } from "app/NativeComponents/snippets";

import {
  appRedirect,
  toggleActionSheet,
  getBilling,
  toggleDealCreditModal,
  toggleOnboarding,
  updateBillingAddon,
  setModal,
  toggleModal,
  setBillingDetails,
  setFeatureModal,
  updatePlan
} from "app/NativeActions";

import DealCredit from "./DealCredit";
import CardOnFile from "./CardOnFile";

class BillingDashboard extends Component {
  componentDidMount() {
    if (
      this.props.user.team_clearance_level < 2 &&
      this.props.user.team_owner != 1
    ) {
      this.handleBack();
    }

    this.props.getBilling({
      token: this.props.token,
      type: "lead_limits"
    });

    this.props.getBilling({
      token: this.props.token,
      type: "conversation_limits"
    });
  }

  handleBack() {
    this.props.appRedirect({
      redirect: "goBack",
      payload: { type: "settings" }
    });
  }

  render() {
    return (
      <Container>
        <Header
          title={"Billing"}
          leftButtonIcon={"arrow-back"}
          leftButtonAction={this.handleBack.bind(this)}
        />
        {this.props.platform !== "ios" ? (
          <KeyboardView>
            <CardOnFile {...this.props} />
            <DealCredit {...this.props} />

            <Card>
              <MenuItem
                style={{
                  borderBottomWidth: 1,
                  borderBottomColor: this.props.colors.border_color,
                  borderBottomStyle: "solid"
                }}
                to="/a/settings/billing/update-card"
                onPress={() =>
                  this.props.appRedirect({ redirect: "cardOnFile" })
                }
                title="Update Card On File"
                text={
                  !this.props.card_info.has_card
                    ? "You do not have a card on file."
                    : "Card ending in " + this.props.card_info.last4
                }
              />
              <MenuItem
                style={{
                  borderBottomWidth: 1,
                  borderBottomColor: this.props.colors.border_color,
                  borderBottomStyle: "solid"
                }}
                to="/a/settings/billing/invoices"
                onPress={() => this.props.appRedirect({ redirect: "invoices" })}
                title="Invoice and Spend Reports"
                text={"View your past invoices."}
              />
            </Card>
          </KeyboardView>
        ) : (
          <KeyboardView>
            <Wrapper>
              <Card>
                <CardBody>
                  <Title>We know it's a hassle.</Title>
                  <Copy>
                    {" "}
                    Check out DealMachine on the web to upgrade and then come
                    back
                  </Copy>
                </CardBody>
              </Card>
            </Wrapper>
          </KeyboardView>
        )}
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, native, settings, billing }) => {
  const { token, user } = auth;
  const { device, platform, isMobile } = native;
  const { colors } = settings;

  const {
    card_info,
    plan_modules,
    deal_credits,
    deal_credits_loading,
    billing_addons,
    loading_lead_limits,
    total_lead_count,
    current_lead_limit,
    additional_limit_price,
    current_billing_cycle_driving_lead_count,
    driving_lead_limit,

    loading_conversation_limits,
    conversation_limit,
    current_billing_cycle_conversation_count
  } = billing;
  return {
    token,
    user,
    colors,
    card_info,
    plan_modules,
    deal_credits,
    deal_credits_loading,
    billing_addons,
    loading_lead_limits,
    total_lead_count,
    current_lead_limit,
    additional_limit_price,
    current_billing_cycle_conversation_count,
    driving_lead_limit,
    loading_conversation_limits,
    conversation_limit,
    current_billing_cycle_driving_lead_count,
    device,
    platform,
    isMobile
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  getBilling,
  toggleActionSheet,
  toggleDealCreditModal,
  toggleOnboarding,
  updateBillingAddon,
  setModal,
  toggleModal,
  setBillingDetails,
  setFeatureModal,
  updatePlan
})(BillingDashboard);
